<template>
  <div>
    <section class="mb-4 mb-lg-5">
      <div class="container">
        <div class="image-header" :style="coverImage">
          <label for="cover" class="btn btn-outline-color2">Adicionar imagem</label>
          <input
            type="file"
            name="cover"
            id="cover"
            style="display: none"
            @change="changeCover"
            accept="image/*"
          />
        </div>
      </div>
    </section>
    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <form
            action=""
            method="POST"
            @submit.prevent="submit"
          >
            <div class="form-group mb-4">
              <input
                type="text"
                class="form-control font-weight-bold font-size-medium bordered-bottom"
                name="name"
                placeholder="Nome da lista"
                v-model.trim="$v.list.name.$model"
              />
            </div>
            <div class="form-group mb-4 col-md-8 mx-md-auto editable-form">
              <span class="font-size-small">{{ baseUrl }}/{{ $route.params.username }}/lists/</span>
              <input
                type="text"
                class="form-control bordered-bottom font-size-small pb-0 text-left"
                name="slug"
                placeholder="URL"
                v-model.trim="$v.list.slug.$model"
              />
            </div>
            <div class="form-group mb-5 col-md-6 mx-md-auto">
              <textarea
                class="form-control bordered-bottom font-size-small w-100"
                name="description"
                placeholder="Descrição da lista"
                v-model.trim="list.description"
              ></textarea>
            </div>
            <div class="form-group mb-4" v-if="list.type && list.type !== 'readlater'">
              <label class="font-size-medium font-weight-bold d-block">Privacidade</label>
              <DropdownSelect
                v-model.trim="$v.list.visibility.$model"
                :options="visibilityOptions"
              />
              <p
                class="font-size-xSmall mt-2 text-color2 mb-0 text-center"
              >
                Dica: {{ visibilityTipText }}
              </p>
            </div>
            <div class="form-group mt-5">
              <Button
                class="btn-primary"
                type="submit"
                :disabled="$v.$invalid"
                :loading="loader"
              >
                Salvar
              </Button>
              <router-link
                class="btn btn-outline-color2 ml-3"
                :to="{ name: 'lists.show', params: { username: $route.params.username, slug: $route.params.slug } }"
              >
                Voltar
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import ListsService from '@/modules/lists/services/lists-service'
import { required } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'
import { checkIfUserIsOwnerOfEntity } from '@/utils'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import DropdownSelect from '@/components/common/Select/DropdownSelect.vue'

export default {
  mixins: [variables],
  components: {
    Button,
    DropdownSelect
  },
  data () {
    return {
      currentList: null,
      loader: false,
      list: {
        name: '',
        slug: '',
        description: '',
        visibility: '',
        type: '',
        cover: null
      }
    }
  },
  metaInfo: {
    title: 'Editar lista'
  },
  validations () {
    return {
      list: {
        name: { required },
        slug: { required },
        visibility: { required }
      }
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    coverImage () {
      return {
        backgroundImage: this.list.cover ? `url('${URL.createObjectURL(this.list.cover)}')` : `url('${this.currentList ? this.currentList.cover : this.noCoverUrl}')`
      }
    },
    visibilityTipText () {
      if (this.list.visibility === 'public') return 'qualquer um poderá ver a lista'
      else if (this.list.visibility === 'private') return 'apenas você poderá ver a lista'
      return ''
    }
  },
  created () {
    if (this.user) this.getList()
  },
  watch: {
    user (newUser, oldUser) {
      if (!this.currentList) this.getList()
    }
  },
  methods: {
    changeCover (e) {
      const file = e.target.files[0]
      this.list.cover = file
    },
    async getList () {
      try {
        const list = await ListsService.getList(this.$route.params.slug)
        checkIfUserIsOwnerOfEntity(list, this.user)
        this.currentList = list
        this.list.name = list.name
        this.list.slug = list.slug
        this.list.description = list.description
        this.list.visibility = list.visibility
        this.list.type = list.type
      } catch (error) {
        // If there is an error, redirect to home
        this.$router.push('/')
      }
    },
    async submit () {
      this.loader = true
      try {
        const list = await ListsService.postList(this.currentList.id, this.list)
        return this.$router.push({ name: 'lists.show', params: { username: list.user.username, slug: list.slug } })
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
